import styled, { css, keyframes, createGlobalStyle } from 'styled-components'
import { ToastContainer } from 'react-toastify'

interface ActionProgressProps {
  paused: boolean
}

interface ToastColorProps {
  color: string
}

interface ActionMessageContainerProps {
  loading: boolean
}

export interface ProgressBarProps {
  color: string
  paused: boolean
}

export const StyledToastContainer = styled(ToastContainer)`
  && {
    width: auto;
    margin-top: 70px;
    z-index: 9999999999999999;
    .toast-message {
      border-radius: 5px;
      min-height: 75px;
      position: relative;
    }

    .Toastify__close-button {
      color: #012d3e;
      position: absolute;
      top: 50%;
      height: 20px;
      width: 20px;
      transform: translateY(-50%);
      right: 20px;
    }
    .Toastify__toast {
      border-radius: 5px;
      display: flex;
      padding: 0;
      align-items: center;
      justify-content: center;
      background: #fff;
    }
    .Toastify__toast--info .Toastify__progress-bar {
      background-color: #0a5b8b;
    }
    .Toastify__toast--error .Toastify__progress-bar {
      background-color: #ff6f61;
    }
    .Toastify__toast--warning .Toastify__progress-bar {
      background-color: #fdda7e;
    }
    .Toastify__toast--success .Toastify__progress-bar {
      background-color: #00a86b;
    }
    .Toastify__toast-body {
      text-align: left;
      margin: 0;
      padding: 0;
      display: flex;
      min-width: auto;
      white-space: pre-line;
    }
  }
`

export const StyledHeader = styled.h3`
  margin-bottom: 10px;
`

export const StyledMessage = styled.p`
  margin: 0 0 0.6rem;
`

export const MessageContainer = styled.div`
  width: 100%;
  padding: 20px 180px 25px 0;
  margin-left: 35px;
`

export const ActionMessageContainer = styled.div<ActionMessageContainerProps>`
  ${({ loading }) => css`
    display: flex;
    align-items: center;
    padding: 8px 24px;
    cursor: default;
    height: 100%;

    span {
      margin: 0 !important;
      color: #fff !important;
    }

    span:last-child {
      margin-left: 48px !important;
      margin-right: 40px !important;
      cursor: pointer;
      padding: 8px;
      border-radius: 3px;

      :hover {
        background: #1a4251;
      }
    }

    ${loading &&
    css`
      span {
        opacity: 0.5;
        cursor: default;
      }
    `}
  `}
`

export const StyledToast = styled.div`
  min-width: max-content;
  display: flex !important;
  position: relative;
  align-items: center;
  color: #012d3e;
`

export const ToastColor = styled.div<ToastColorProps>`
  ${({ color }) => css`
    min-height: 100%;
    background: ${color};
    min-width: 40px;
    border-radius: 5px 0 0 5px;
  `}
`

export const ToastIcon = styled.img`
  position: absolute;
  width: 50px;
  left: 15px;
`
const progress = keyframes`
  from {
    width: 0;
  }
  to {
   width: 100%; 
  }
`

export const ProgressContainer = styled.div`
  width: 70px;
  position: relative;
`
export const Track = styled.div`
  background-color: #012d3e;
  opacity: 0.1;
  height: 5px;
  border-radius: 15px;
  width: 100%;
`

export const Progress = styled.div<ProgressBarProps>`
  ${({ color, paused }) => css`
    position: absolute;
    z-index: 100;
    animation: ${progress} 5s linear forwards;
    top: 0;
    width: 0;
    height: 5px;
    border-radius: 15px;
    width: 100%;
    background-color: ${color};
    animation-play-state: ${paused ? 'paused' : 'playing'};
  `}
`

export const ActionProgressContainer = styled.div`
  display: flex;
  width: 100%;
  position: absolute;
  bottom: 0;
`
export const ActionTrack = styled.div`
  background-color: #012d3e;
  opacity: 0.1;
  height: 5px;
  border-radius: 15px;
  width: 100%;
`

export const ActionProgress = styled.div<ActionProgressProps>`
  ${({ paused }) => css`
    position: absolute;
    z-index: 100;
    animation: ${progress} 5s linear forwards;
    top: 0;
    width: 0;
    height: 5px;
    border-radius: 15px;
    width: 100%;
    background-color: #7e61ff;
    animation-play-state: ${paused ? 'paused' : 'playing'};
  `}
`

// @ts-ignore
export const GlobalActionStyles = createGlobalStyle`
${({ theme }) => css`
  .Toastify__toast--default {
    &.Toastify__toast {
      background: ${theme.colors.abyss} !important;
      box-shadow: 0px 3px 8px rgba(0, 46, 62, 0.04) !important;
      border-radius: 4px !important;
      flex-direction: column !important;
    }

    .Toastify__close-button {
      color: #bdcbd0 !important;
      right: 24px !important;
      opacity: 1 !important;
      height: 40px !important;
      width: 40px !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;

      :hover {
        background: #1a4251 !important;
      }
    }
  }
`}
`
